module.exports = __webpack_public_path__ + "static/media/save-money.e469c915.svg";